var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isValid)?_c('div',{staticClass:"d-inline-block"},[_vm._v(" "+_vm._s(_vm.formattedDateTime)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }